import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import formatCurrency from "../../../utils/formatCurrency";
import { Details, VariantName, VariantPrice } from "./styles";
import { Variant } from "./types";

interface Props {
  variant: Variant;
  selectedVariant?: Variant;
  setSelectedVariant: (selected: Variant) => void;
}

const VariantPriceDetails = ({ variant, selectedVariant, setSelectedVariant }: Props) => {
  const { locale } = useIntl();
  const price = useMemo(() => formatCurrency(variant.price, locale), [locale, variant.price]);
  return (
    <Details
      key={variant.id}
      onClick={() => setSelectedVariant(variant)}
      selected={variant.id === selectedVariant?.id}
      aria-label={variant?.displayName}
      data-testid={`variant-${variant.id}`}
    >
      <VariantName>{variant?.displayName}</VariantName>
      <VariantPrice>
        {price}
      </VariantPrice>
    </Details>
  );
};

export default VariantPriceDetails;
